module.exports = __webpack_public_path__ + "static/media/PM52.644337fc.png";